// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"UI_spinnerContainer__JLrGw","spinnerBox":"UI_spinnerBox__cZIGz"};